import { useEffect } from 'react';

import { useAppSelector } from '../../../redux/hooks';

import MedicationComponent from './component';

import { useCreateMedication } from './hooks';

import { medicationSchema } from './schema';
import { addMedicationProps, TMedicationInitialValues } from './types';
import { MEDICATION_FORM_FIELD_DATA } from '../../../constants/medication';

const AddMedication = ({ isModalOpen, setIsModalOpen }: addMedicationProps) => {
  const initialValues: TMedicationInitialValues = {
    name: '',
    dosage: '',
    frequency: '',
    details: '',
    reminder: false,
    dosageFrequency: null,
    reminderStartDate: new Date(),
    reminderEndDate: null,
  };

  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const { submitPatientMedication, isSuccess } = useCreateMedication();

  const handleSave = (values: TMedicationInitialValues) => {
    submitPatientMedication({
      name: values.name,
      dosage: values.dosage,
      frequency: values.frequency,
      details: values.details,
      patientId: currentUser?.id,
      reminder: values.reminder,
      dosageFrequency: values.dosageFrequency,
      reminderStartDate: values.reminderStartDate,
      reminderEndDate: values.reminderEndDate,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      setIsModalOpen(false);
    }
  }, [isSuccess, setIsModalOpen]);

  return (
    <MedicationComponent
      initialValues={initialValues}
      formFieldData={MEDICATION_FORM_FIELD_DATA}
      isModalOpen={isModalOpen}
      validationSchema={medicationSchema}
      setIsModalOpen={setIsModalOpen}
      handleSave={handleSave}
    />
  );
};

export default AddMedication;
